import { ErrorLayout } from "../../components/ErrorLayout";
import { LoginPage } from "../../modules/login";
import { ForgotPasswordPage } from "../../modules/forgot-password";
import { ResetPasswordPage } from "../../modules/reset-password";

export const authRoutes = [
  {
    path: "/login",
    element: <LoginPage />,
    errorElement: <ErrorLayout />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
    errorElement: <ErrorLayout />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
    errorElement: <ErrorLayout />,
  },
];
